import { PageContainer, PageHeader } from '@/components/Atoms'
import { useProductTypeMappingsLastUpdated } from '@/hooks/queries/crt/useProductTypes'
import { useProductTypeVariantSummary } from '@/hooks/queries/crt/useProductTypeVariant'
import { toUpdatedAt } from '@/lib/utils/getLastUpdatedState'
import {
  DataSources,
  type DataSourceItem,
} from '@/routes/_auth/_modules/_shared/-components/DataSources'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/_modules/crt/materials/data-sources/')({
  component: MaterialsDataSources,
})

function MaterialsDataSources() {
  const { t } = useTranslation(['crt', 'common'])

  const { data: productTypeVariantSummary } = useProductTypeVariantSummary()
  const { data: productTypesLastUpdated } = useProductTypeMappingsLastUpdated()

  const automatedImports: DataSourceItem[] = [
    {
      name: t('route.crt.productTypeVariants', { ns: 'common' }),
      frequency: t('dataSources.frequency.daily'),
      frequencySchedule: { type: 'daily' },
      updatedAt: toUpdatedAt(productTypeVariantSummary),
      description: t('materialsDataSources.productTypeVariants.linkText'),
      link: { to: '/crt/materials/data-sources/product-type-variants' },
      permissions: ['crt_product_type_variant_view'],
    },
  ]

  const assumptions: DataSourceItem[] = [
    {
      name: t('route.crt.unreleasedMaterials', { ns: 'common' }),
      description: t('materialsDataSources.unreleasedMaterials.linkText'),
      link: { to: '/crt/materials/data-sources/unreleased-materials' },
      permissions: ['crt_unreleased_materials_view'],
    },
    {
      name: t('route.crt.productTypes', { ns: 'common' }),
      description: t('materialsDataSources.productTypes.linkText'),
      updatedAt: toUpdatedAt(productTypesLastUpdated),
      link: { to: '/crt/materials/data-sources/product-types' },
      permissions: ['crt_product_types_view'],
    },
    {
      name: t('route.crt.materialGroupOverrides', { ns: 'common' }),
      description: t('materialsDataSources.materialGroupOverrides.linkText'),
      link: { to: '/crt/materials/data-sources/material-groups-overrides' },
      permissions: ['crt_material_group_overrides_view'],
    },
  ]

  return (
    <PageContainer>
      <PageHeader>{t('materialsDataSources.pageHeader')}</PageHeader>
      <DataSources automatedImports={automatedImports} assumptions={assumptions} />
    </PageContainer>
  )
}
